export default {
  title: 'Comprar e-gift cards',
  subtitle:
    'Diga tudo com um gift card de {{companyName}}. Perfeito para aniversários, um obrigado ou simplesmente porque sim – utilizável em comida e bebidas.',
  header: {
    title: 'Gift Card',
    subtitle: 'Ofereça alegria',
  },
  buttons: {
    buy_now: 'Comprar agora',
  },
};
